import { IProductVariant } from '../models/product-variant.model';

export function getProductVariants(
    variants: IProductVariant[],
    attrArr: { value: number | string }[]
) {
    const values = attrArr.map((attr) => attr.value);
    return variants.filter((variant) => {
        const variantValues = variant.attributesValues.map((attr) => attr.value);
        return values.every((value) => {
            return variantValues.includes(value);
        });
    });
}
